const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export const formatBookingPrice = (cents) => formatter.format(cents / 100);

// Stripe API units, not Intl/ISO fraction digits:
// https://docs.stripe.com/currencies#zero-decimal
// ISK/UGX use two-place compatibility units. HUF/TWD payouts must be
// divisible by 100, but their API balances and payouts still use those units.
const stripeZeroDecimal = new Set([
  "BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA",
  "PYG", "RWF", "VND", "VUV", "XAF", "XOF", "XPF",
]);
export const formatPayoutAmount = (amount, currency) => {
  const code = String(currency || "").toUpperCase();
  if (!/^[A-Z]{3}$/.test(code) || !Number.isSafeInteger(amount)) return "—";
  const zeroDecimal = stripeZeroDecimal.has(code);
  const payoutFormatter = new Intl.NumberFormat("en-US", {
    style: "currency", currency: code,
    ...(zeroDecimal ? { minimumFractionDigits: 0, maximumFractionDigits: 0 } : {}),
  });
  return payoutFormatter.format(amount / (zeroDecimal ? 1 : 100));
};
